<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <PageHead label='科秘书考评' label2="新增评分" url="/achievement/sectionsecretary/scorerecordlist"></PageHead>
      <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed" :model="form" ref="form">
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <div style="width: 100%;overflow: auto;">
            <div class="form-group m-form__group row" style="padding-top: 30px;">
              <label class="col-xl-1 col-form-label m--align-center">年份：</label>
              <div class="col-xl-3 m--align-left">
                <el-form-item prop="year" :rules="{required: true, message: '年份不能为空', trigger: 'blur'}">
                  <el-select v-model="form.year" filterable placeholder="请选择">
                    <el-option label="请选择" value=""></el-option>
                    <el-option v-for="item in yearOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <label class="col-xl-1 col-form-label m--align-right">季度：</label>
              <div class="col-xl-3 m--align-left">
                <el-form-item prop="quarter" :rules="{required: true, message: '季度不能为空', trigger: 'blur'}">
                  <el-select v-model="form.quarter" filterable placeholder="请选择">
                    <el-option label="请选择" value=""></el-option>
                    <el-option v-for="item in quarterOptions" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div v-html="tabHead">
            </div>
            <div class="divStuScore">
              <el-table :data="form.tableData" style="width: 2250px;margin-bottom: 10px;" stripe border
                header-row-class-name="hideRow" v-loading="loading">
                <el-table-column label="姓名" width="150">
                  <template slot-scope="scope">
                    <span>{{scope.row.CPIDName}}({{scope.row.CPIDNo}})</span><br>
                    <span>{{scope.row.CPIDSecName}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="内容1" width="100">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.CPIDContent1"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="得分1" width="100">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.CPIDScore1" @blur="InputBlur(scope.row,1)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="内容2" width="100">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.CPIDContent2"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="得分2" width="100">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.CPIDScore2" @blur="InputBlur(scope.row,2)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="内容3" width="100">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.CPIDContent3"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="得分3" width="100">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.CPIDScore3" @blur="InputBlur(scope.row,3)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="内容4" width="100">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.CPIDContent4"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="得分4" width="100">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.CPIDScore4" @blur="InputBlur(scope.row,4)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="内容5" width="100">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.CPIDContent5"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="得分5" width="100">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.CPIDScore5" @blur="InputBlur(scope.row,5)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="内容6" width="100">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.CPIDContent6"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="得分6" width="100">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.CPIDScore6" @blur="InputBlur(scope.row,6)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="内容7" width="100">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.CPIDContent7"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="得分7" width="100">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.CPIDScore7" @blur="InputBlur(scope.row,7)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="内容8" width="100">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.CPIDContent8"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="得分8" width="100">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.CPIDScore8" @blur="InputBlur(scope.row,8)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="内容9" width="100">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.CPIDContent9"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="得分9" width="100">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.CPIDScore9" @blur="InputBlur(scope.row,9)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="内容10" width="100">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.CPIDContent10"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="得分10" width="100">
                  <template slot-scope="scope">
                    <el-form :model="scope.row">
                      <el-input v-model="scope.row.CPIDScore10" @blur="InputBlur(scope.row,10)"></el-input>
                    </el-form>
                  </template>
                </el-table-column>
                <el-table-column label="总分" width="100">
                  <template slot-scope="scope">
                    {{ scope.row.CPIDScore = scope.row.CPIDScore1 * 1 + scope.row.CPIDScore2 * 1 + scope.row.CPIDScore3 * 1 + scope.row.CPIDScore4 * 1 + scope.row.CPIDScore5 * 1 + scope.row.CPIDScore6 * 1 + scope.row.CPIDScore7 * 1 + scope.row.CPIDScore8 * 1 + scope.row.CPIDScore9 * 1 + scope.row.CPIDScore10 * 1 }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit">
          <div class="m-form__actions m-form__actions--solid">
            <div class="row">
              <div class="col-lg-12 m--align-center">
                <el-button v-if="this.index > 0" type="success" icon="el-icon-s-order" @click="Add" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SectionSecretaryScore',
    data() {
      return {
        form: {
          username: '',
          rolelevel: '',
          secid: '',
          token: '',
          year: '',
          quarter: '',
          cpitype: 3,
          cpistatus: 1,
          tableData: [],
          sec: ''
        },
        yearOptions: [],
        quarterOptions: [{
          value: '1',
          label: '一季度'
        }, {
          value: '2',
          label: '二季度'
        }, {
          value: '3',
          label: '三季度'
        }, {
          value: '4',
          label: '四季度'
        }],
        tabHead: '',
        stuOptions: null,
        index: 0,
        fileList: [],
        fullscreenLoading: false,
        loading: true
      }
    },
    methods: {
      AddInfo() {
        let newLine = {
          CPIDPersonID: '',
          CPIDName: '',
          CPIDContent1: '',
          CPIDScore1: '',
          CPIDContent2: '',
          CPIDScore2: '',
          CPIDContent3: '',
          CPIDScore3: '',
          CPIDContent4: '',
          CPIDScore4: '',
          CPIDContent5: '',
          CPIDScore5: '',
          CPIDContent6: '',
          CPIDScore6: '',
          CPIDContent7: '',
          CPIDScore7: '',
          CPIDContent8: '',
          CPIDScore8: '',
          CPIDContent9: '',
          CPIDScore9: '',
          CPIDContent10: '',
          CPIDScore10: '',
          CPIDScore: ''
        }
        this.index += 1
        newLine.etdindex = this.index
        this.form.tableData.push(newLine)
      },
      Add: function() {
        if (this.form.year == '') {
          this.$message({
            message: '请选择年份',
            type: 'error'
          })
          return
        }
        if (this.form.quarter == '') {
          this.$message({
            message: '请选择季度',
            type: 'error'
          })
          return
        }
        this.$http.post(this.$utils.Url.zpgl + '/api/APISecretaryScore/AddScore', this.form)
          .then(res => {
            console.log(res.data)
            if (res.data.Code === 0) {
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              console.log('保存成功')
              this.$router.push('/main/achievement/sectionsecretary/scorerecordlist')
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
          })
          .catch(err => {
            console.log(err)
            this.$message({
              message: '保存失败',
              type: 'error'
            })
          })
      },
      LoadTabHead: function() {
        this.$http.post(this.$utils.Url.zpgl + '/api/APISecretaryScore/SecretaryScoreTabHead', this.form)
          .then(res => {
            if (res.data.Code === 0) {
              this.tabHead = res.data.Data
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
          })
          .catch(err => {
            this.tabHead = ''
            console.log(err)
            this.$message({
              message: '查询失败',
              type: 'error'
            })
          })
      },
      LoadScoreSectionSecretary: function() {
        this.loading = true
        this.$http.post(this.$utils.Url.zpgl + '/api/APISecretaryScore/ScoreSecretary', this.form)
          .then(res => {
            if (res.data.Code === 0) {
              this.form.tableData = res.data.Data
              this.index = res.data.Pager.RecordCount
            } else {
              this.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
            this.loading = false
          })
          .catch(err => {
            this.form.tableData = null
            this.index = 0
            console.log(err)
            this.$message({
              message: '查询失败',
              type: 'error'
            })
            this.loading = false
          })
      },
      InputBlur: function(row, index) {
        if (index == 1) {
          if (row.CPIDScore1 > row.MaxScore1) {
            row.CPIDScore1 = row.MaxScore1
          }
          if (isNaN(row.CPIDScore1)) {
            row.CPIDScore1 = 0
          } else {
            if (row.CPIDScore1 < 0) {
              row.CPIDScore1 = 0
            }
          }
        } else if (index == 2) {
          if (row.CPIDScore2 > row.MaxScore2) {
            row.CPIDScore2 = row.MaxScore2
          }
          if (isNaN(row.CPIDScore2)) {
            row.CPIDScore2 = 0
          } else {
            if (row.CPIDScore2 < 0) {
              row.CPIDScore2 = 0
            }
          }
        } else if (index == 3) {
          if (row.CPIDScore3 > row.MaxScore3) {
            row.CPIDScore3 = row.MaxScore3
          }
          if (isNaN(row.CPIDScore3)) {
            row.CPIDScore3 = 0
          } else {
            if (row.CPIDScore3 < 0) {
              row.CPIDScore3 = 0
            }
          }
        } else if (index == 4) {
          if (row.CPIDScore4 > row.MaxScore4) {
            row.CPIDScore4 = row.MaxScore4
          }
          if (isNaN(row.CPIDScore4)) {
            row.CPIDScore4 = 0
          } else {
            if (row.CPIDScore4 < 0) {
              row.CPIDScore4 = 0
            }
          }
        } else if (index == 5) {
          if (row.CPIDScore5 > row.MaxScore5) {
            row.CPIDScore5 = row.MaxScore5
          }
          if (isNaN(row.CPIDScore5)) {
            row.CPIDScore5 = 0
          } else {
            if (row.CPIDScore5 < 0) {
              row.CPIDScore5 = 0
            }
          }
        } else if (index == 6) {
          if (row.CPIDScore6 > row.MaxScore6) {
            row.CPIDScore6 = row.MaxScore6
          }
          if (isNaN(row.CPIDScore6)) {
            row.CPIDScore6 = 0
          } else {
            if (row.CPIDScore6 < 0) {
              row.CPIDScore6 = 0
            }
          }
        } else if (index == 7) {
          if (row.CPIDScore7 > row.MaxScore7) {
            row.CPIDScore7 = row.MaxScore7
          }
          if (isNaN(row.CPIDScore7)) {
            row.CPIDScore7 = 0
          } else {
            if (row.CPIDScore7 < 0) {
              row.CPIDScore7 = 0
            }
          }
        } else if (index == 8) {
          if (row.CPIDScore8 > row.MaxScore8) {
            row.CPIDScore8 = row.MaxScore8
          }
          if (isNaN(row.CPIDScore8)) {
            row.CPIDScore8 = 0
          } else {
            if (row.CPIDScore8 < 0) {
              row.CPIDScore8 = 0
            }
          }
        } else if (index == 9) {
          if (row.CPIDScore9 > row.MaxScore9) {
            row.CPIDScore9 = row.MaxScore9
          }
          if (isNaN(row.CPIDScore9)) {
            row.CPIDScore9 = 0
          } else {
            if (row.CPIDScore9 < 0) {
              row.CPIDScore9 = 0
            }
          }
        } else if (index == 10) {
          if (row.CPIDScore10 > row.MaxScore10) {
            row.CPIDScore10 = row.MaxScore10
          }
          if (isNaN(row.CPIDScore10)) {
            row.CPIDScore10 = 0
          } else {
            if (row.CPIDScore10 < 0) {
              row.CPIDScore10 = 0
            }
          }
        } else {
          console.log('empty')
        }
      },
      LoadYear: function() {
        var now = new Date()
        var y = now.getFullYear()

        for (var i = 0; i <= 20; i++) {
          var year = y - i
          var args = {
            value: year,
            label: year
          }

          this.yearOptions.push(args)
        }
      }
    },
    mounted: function() {
      this.form.token = sessionStorage.getItem('token')
      this.form.sec = sessionStorage.getItem('secid')
      this.form.username = sessionStorage.getItem('username')
      this.form.rolelevel = sessionStorage.getItem('rolelevel')
      this.form.secid = sessionStorage.getItem('secid')
      this.LoadYear()
      this.LoadTabHead()
      this.LoadScoreSectionSecretary()
    }
  }
</script>

<style scoped="scoped">
  @import '../../../assets/css/stuscore.css'
</style>
